<section id="register" class="component component--register register">
	<div class="wrapper">
		<h2 class="component__title text-center" *ngIf="registerData.rb_title != ''" [innerHtml]="registerData.rb_title"></h2>
		<div class="category__wrapper">
			<div class="register__category category row" *ngIf="registerData.registration_types != ''">
				<div class="col-sm-3 register__category-repeater {{rtVal.registration_status}}" *ngFor="let rtVal of registerData.registration_types">
					<div class="register__category-repeater-col">
					<div class="category__highlight">
						<div class="category__tag" *ngIf="rtVal.registration_tag != ''" [innerHtml]="rtVal.registration_tag"></div>
					</div>
					<figure *ngIf="rtVal.registration_image">
						<img src="{{rtVal.registration_image.sizes.medium_large}}" class="img-responsive" *ngIf="!this.isMobile" width="275">
						<img src="{{rtVal.registration_image.sizes.medium}}" class="img-responsive" *ngIf="isMobile" width="275" style="margin: auto;">
					</figure>
					<div class="category__content">
						<div class="category__status" *ngIf="rtVal.registration_status != 'closed'">
							<a href="{{ rtVal.registration_link.url }}" target="{{ rtVal.registration_link.target }}" class="btn btn-status btn-circle">{{ rtVal.registration_link.title != '' ? rtVal.registration_link.title : rtVal.registration_status }} <span class="btn__arrow"><i class="icon-breadcrumb-right"></i></span></a>
						</div>
						<div class="category__status" *ngIf="rtVal.registration_status != 'open'"><span class="btn btn-status btn-circle" [innerHtml]="rtVal.registration_status"></span></div>
					</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>